import { SVGProps } from 'react';

interface ArrowProps extends SVGProps<SVGSVGElement> {
	testId?: string;
}

const Arrow = (props: ArrowProps) => {
	const { testId = 'Arrow', ...svgProps } = props;
	return (
		<svg
			data-testid={testId}
			xmlns="http://www.w3.org/2000/svg"
			fill="none"
			viewBox="0 0 10 6"
			aria-label="Arrow pointing down"
			{...svgProps}
		>
			<path
				stroke="#64748B"
				strokeLinecap="round"
				strokeLinejoin="round"
				strokeWidth="1.5"
				d="m1 1 4 4 4-4"
			/>
		</svg>
	);
};

export default Arrow;
